exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".section-group{border-radius:5px;padding:10px;margin-bottom:10px;background:#fff}.section-group .label{color:#292929;font-weight:500;font-size:15px}", ""]);

// exports
